import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { PermissionService } from '@core/services/permission-service/permission-service'
import { PERMISSIONS } from '@app/core/constants/permissions.constants'
import { canAccessAcademicCalendar } from './academic-calendar-access.util'

/**
 * Allows academic calendar when IAM grants `view_academic_calendar`, or when that permission
 * is not yet in the catalog but the user's bitmask enables every known catalog permission
 * (typical super-admin / full-access users). Avoids failed guard → `/` → schoolSiteGuard loop.
 */
export const academicCalendarAccessGuard: CanActivateFn = async () => {
    const permissionService = inject(PermissionService)
    const router = inject(Router)

    await permissionService.getPermissionsBitwise()

    if (canAccessAcademicCalendar(permissionService, PERMISSIONS.VIEW_ACADEMIC_CALENDAR)) {
        return true
    }

    await router.navigate(['/'])
    return false
}
